/* unplugin-vue-components disabled */import script from "./AdditionalFeesManager.vue?vue&type=script&setup=true&lang=js"
export * from "./AdditionalFeesManager.vue?vue&type=script&setup=true&lang=js"

import "./AdditionalFeesManager.vue?vue&type=style&index=0&id=a899e1c6&lang=scss"

const __exports__ = script;

export default __exports__